module.exports = __webpack_public_path__ + "static/icon-left-circle.f24b4360.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-left-circle.png
// module id = 1016
// module chunks = 2